export default __webpack_public_path__ + "static/media/5.6bc0f9ec.jpg";